module.exports = __webpack_public_path__ + "img/9788960178618.8777abf9.jpg";